import ProfileImageComp from "../../../common/profile";
import { Cross } from "../../../../icons";
import {
  ChannelInfoIcon,
  ChannelMuteNotificationIcon,
  ChannelReportIcon,
  ChannelSearchTextIcon,
  ChannelThreeDotsIcon,
} from "../../../../icons/group-chat-icons";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../../../constants/routes";

const CustomChannelHeader = ({
  selectedUserData = {},
  handleLeftPanelWithList,
  setGroupInfoVisible,
  handleLeaveGroup,
  setShowSearch,
  showSearch,
  JumpToMessage,
  hideLeftPanel,
}: any) => {
  const otherUserDetails: any = selectedUserData?.user;
  const [visible, setVisible] = useState(false);
  const navigate = useNavigate();

  return (
    <div className="flex items-center bg-white shadow-lg rounded-t-lg p-4 py-3 max-w-full border-b border-b-primary-200 ">
      <div className="flex items-center w-full cursor-pointer">
        <div className="flex-shrink-0 mr-4">
          <div className="h-10 w-10 rounded-full bg-primary-200">
            <ProfileImageComp
              imageUrl={otherUserDetails?.image}
              customClass="h-10 w-10"
              is_opc={otherUserDetails?.memberships?.is_opc}
            />
          </div>
        </div>
        <div
          className="flex flex-col justify-center"
          onClick={() => {
            if (selectedUserData?.type !== "team") {
              navigate(
                ROUTES.USER_PROFILE.replace(":user_id", otherUserDetails?.id),
              );
            }
          }}
        >
          <div className="text-lg font-bold">{otherUserDetails?.name}</div>
          <div className="text-neutral-700 text-sm w-72 truncate">
            {selectedUserData?.members
              ? selectedUserData.members.join(", ")
              : "Tap to see all info"}
          </div>
        </div>
      </div>
      {selectedUserData?.type === "team" && (
        <div onClick={() => setVisible(!visible)} className="mr-2 relative">
          <div className="cursor-pointer">
            <ChannelThreeDotsIcon />
          </div>
          <div
            className={`bg-white ${visible ? "z-100 absolute top-4 -left-36" : "hidden"}`}
          >
            <ul className="absolute z-10 w-48 bg-[#FFFFFF] shadow-xl flex flex-col rounded-lg text-md border-[1px] cursor-pointer overflow-hidden">
              <li
                className="flex gap-2 items-center w-full p-2 px-4 hover:bg-[#EBEBEB]"
                onClick={() => setGroupInfoVisible(true)}
              >
                <ChannelInfoIcon /> <p>Group Info</p>
              </li>
              <li
                className="flex gap-2 items-center w-full p-2 px-4 border-y-[1px] hover:bg-[#EBEBEB]"
                onClick={() => setShowSearch(true)}
              >
                <ChannelSearchTextIcon />
                <p>Search</p>
              </li>
              <li className="flex gap-2 items-center w-full p-2 px-4 border-b-[1px] hover:bg-[#EBEBEB]">
                <ChannelMuteNotificationIcon />
                <p>Mute Notifications</p>
              </li>
              <li
                className="flex gap-2 items-centerw-full p-2 px-4 hover:bg-[#EBEBEB]"
                onClick={handleLeaveGroup}
              >
                <ChannelReportIcon />
                <p className="text-[#FF271B]">Report</p>
              </li>
            </ul>
          </div>
        </div>
      )}
      <div
        className="ml-auto text-gray-500 hover:text-gray-700 cursor-pointer"
        onClick={() => {
          handleLeftPanelWithList();
          hideLeftPanel();
        }}
      >
        <Cross />
      </div>
      {showSearch ? <JumpToMessage /> : <></>}
    </div>
  );
};

export default CustomChannelHeader;
